import { Button } from "@/components/ui/button";
import { Plus, LayoutDashboard } from "lucide-react";
import { Link } from "wouter";

interface PageHeaderProps {
  title: string;
  description?: string;
  actionButton?: {
    label: string;
    onClick: () => void;
    icon?: any;
    disabled?: boolean;
  };
  secondaryButton?: {
    label: string;
    onClick: () => void;
    variant?: "outline" | "default";
    icon?: any;
    disabled?: boolean;
  };
  tertiaryButton?: {
    label: string;
    onClick: () => void;
    variant?: "outline" | "default";
    icon?: any;
    disabled?: boolean;
  };
}

export default function PageHeader({ title, description, actionButton, secondaryButton, tertiaryButton }: PageHeaderProps) {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Link href="/">
            <Button
              variant="ghost"
              size="sm"
              className="mr-4 p-2"
            >
              <LayoutDashboard className="h-12 w-12 text-blue-600" />
            </Button>
          </Link>
          <div>
            <h2 className="text-2xl font-semibold text-gray-900">{title}</h2>
            {description && <p className="text-sm text-gray-600 mt-1">{description}</p>}
          </div>
        </div>
        <div className="flex items-center space-x-4">
          {tertiaryButton && (
            <Button
              variant={tertiaryButton.variant || "outline"}
              onClick={tertiaryButton.onClick}
              disabled={tertiaryButton.disabled}
            >
              {tertiaryButton.icon && <tertiaryButton.icon className="mr-2 h-4 w-4" />}
              {tertiaryButton.label}
            </Button>
          )}
          {secondaryButton && (
            <Button 
              variant={secondaryButton.variant || "outline"}
              onClick={secondaryButton.onClick}
              disabled={secondaryButton.disabled}
            >
              {secondaryButton.icon && <secondaryButton.icon className="mr-2 h-4 w-4" />}
              {secondaryButton.label}
            </Button>
          )}
          {actionButton && (
            <Button 
              onClick={actionButton.onClick}
              disabled={actionButton.disabled}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {actionButton.icon && <actionButton.icon className="mr-2 h-4 w-4" />}
              {actionButton.label}
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}